// extracted by mini-css-extract-plugin
module.exports = {"falseForm":"_1CTaZo","falseButton":"_2Hr86l"};